import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/documents")({
  staticData: {
    permission: PERMISSIONS.RH.DOCUMENTS.VIEW,
  },
  component: () => <Outlet />,
});
